export function millisToMinutesAndSeconds(millis) {
  if (millis === null) return '';

  var minutes = Math.floor(millis / 60000);
  var seconds = (millis % 60000) / 1000;
  return (minutes < 10 ? '0' + minutes : minutes) + ':' + (seconds < 10 ? '0' : '') + seconds.toFixed(0);
}

export function timeConversion(duration: number) {
  const portions: string[] = [];

  const msInHour = 1000 * 60 * 60;
  const hours = Math.trunc(duration / msInHour);
  if (hours > 0) {
    if (hours > 10) return hours.toLocaleString();

    portions.push(hours + ':');
    duration = duration - hours * msInHour;
  }

  const msInMinute = 1000 * 60;
  const minutes = Math.trunc(duration / msInMinute);
  if (minutes > 0) {
    portions.push(minutes + ':');
    duration = duration - minutes * msInMinute;
  } else portions.push('0:');

  const seconds = Math.trunc(duration / 1000);
  if (seconds > 0) {
    portions.push(seconds + '');
  }

  return portions.join('');
}
